import React from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import NavBar from './NavBar/NavBar';
import { Alert, Snackbar } from '@mui/material';
import { useAlert } from 'common/alertContext';

const Layout = () => {
  const { stateAlert, setStateAlert } = useAlert();

  const handleOnClose = () => {
    setStateAlert((previousState) => ({ ...previousState, open: false }));
  };

  return (
    <React.Fragment>
      <Box sx={{ height: '100%', backgroundColor: 'background.secondary', overflowY: 'auto' }}>
        <NavBar />
        <Box
          sx={{
            display: 'flex',
            height: '100%',
            flexDirection: 'column',
            padding: '0',
          }}>
          <Outlet />
        </Box>
      </Box>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        open={stateAlert.open}
        autoHideDuration={3000}
        onClose={handleOnClose}>
        <Alert severity={stateAlert.type} variant="filled" sx={{ width: '100%' }} onClose={handleOnClose}>
          {stateAlert.message}
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
};

export default Layout;
